import { useEffect, useRef, useState } from "react";
import { Accordion, Col, Container, FloatingLabel, Form, Row } from "react-bootstrap";
import Draggable from 'react-draggable';
import { toast } from "react-toastify";
import {
    useGetDivisionListQuery,
    useLazyGetAssignedOrdersToDriverQuery,
    useLazyGetDriverNumberListQuery,
    useLazyGetDriversFromBoardQuery,
    useLazyGetSelectedOrderDetailsQuery
} from "../../../features/Dispatch/DispatchSlice";
import {
    useAssignTripToOrderMutation,
    useGetDriversForTransferOptionsQuery,
    useGetOrdersByTripQuery, useLazyGetAllOpenTripOrdersQuery, useLazyGetSelectedTripDetailsQuery,
    useLazyGetTripOrdersClassificationQuery, useGetVehiclesByDivisionQuery, useGetServicesByDivisionQuery
} from "../../../features/Dispatch/TripDispatchSlice";
import '../../../style.css';
import Button from "../../designSystem/Button/Button";
import TextField from "../../designSystem/TextField";
import Wrapper from "../../Wrapper";
import DriverDetails from "../SamedayDispatch/DriverDetails";
import OrderDetailsMin from "../SamedayDispatch/OrderDetails/OrderDetailsMin";
import NowLater from "./../SamedayDispatch/NowLater";
import ActiveTripList from "./ActiveTripList";
import AddActiveDriver from "./AddActiveDriver";
import DriverList from "./DriverList";
import DynamicOrdersTable from "./DynamicOrdersTable";
import LoadingPage from "./LoadingPage";
import TransferDelivery from "./TransferDelivery";
import TransferPickup from "./TransferPickup";
import RemoveDriver from "./RemoveDriver";
import PickupModal from "./PickupModal";
import RemoveTrip from "./RemoveTrip";
import RemoveDriverCheckbox from "./RemoveDriverCheckbox";

const TripDispatch = () => {
    const [isOpen, setisOpen] = useState(1)
    const { data: divisionList } = useGetDivisionListQuery()
    const [selectedOrder, setSelectedOrder] = useState(null)
    const [selectedDriver, setSelectedDriver] = useState(null)
    const [divisionId, setDivisionId] = useState(null)
    const [assignedOrders, setAssignedOrders] = useState([])
    const [getAssignedOrdersToDriver] = useLazyGetAssignedOrdersToDriverQuery();
    const [nowLater, setNowLater] = useState('now');
    const [fetchDrivers, result] = useLazyGetDriversFromBoardQuery();
    const [getDriverList, driverListResult] = useLazyGetDriverNumberListQuery()
    const divisionIdRef = useRef();
    const [getDetails, singleOrderData] = useLazyGetSelectedOrderDetailsQuery();
    const [showNewTrip, setShowNewTrip] = useState(false);
    const [showPickupModal, setShowPickupModal] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [assignTripToOrder] = useAssignTripToOrderMutation();
    const [getAllOpenTripOrders, ordersResult] = useLazyGetAllOpenTripOrdersQuery();
    const [orderNumber, setOrderNumber] = useState(null);
    const [orderID, setOrderID] = useState(null);
    const [showPickupTransfer, setShowPickupTransfer] = useState(false);
    const [showDeliveryTransfer, setShowDeliveryTransfer] = useState(false);
    const [isEditActiveTrip, setIsEditActiveTrip] = useState(false);
    const [getSelectedTripDetails, selectedTripDetails] = useLazyGetSelectedTripDetailsQuery()
    const [getTripOrdersClassification, tripOrdersClassification] = useLazyGetTripOrdersClassificationQuery();
    const [assignDriverCheckbox, setAssignDriverCheckbox] = useState(false);
    const { data: orederByTripData, refetch: refetchTripOrders } = useGetOrdersByTripQuery(
        { tripId: selectedTrip?.tripID, divisionId: divisionId },
        { skip: !selectedTrip || !divisionId }
    );
    const { data: driversForTransferOptions } = useGetDriversForTransferOptionsQuery();
    const selectedDriverForTransfer = driversForTransferOptions?.data?.find(driver => driver.driverID === selectedDriver?.driverId);
    const transferDriverId = divisionList?.data?.find(division => division.divisionName === selectedDriverForTransfer?.name)?.divisionId;
    const { data: vehiclesByDivision } = useGetVehiclesByDivisionQuery(transferDriverId, { skip: !transferDriverId });
    const { data: servicesByDivision } = useGetServicesByDivisionQuery(transferDriverId, { skip: !transferDriverId });
    const driverType = result?.data?.data?.find(driver => driver.driverNumber === selectedDriver?.driverNumber)?.driverType;
    const [removeID, setRemoveID] = useState(null);
    const [classificationRadio, setClassificationRadio] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [removeDriverPopup, setRemoveDriverPopup] = useState(false);
    const [showRemoveDriverCheckbox, setShowRemoveDriverCheckbox] = useState(false);
    const removeOrder = removeID ? ordersResult?.data?.data?.find(order => order.orderID === removeID) : null;
    const removeOrderTrip = removeID ? orederByTripData?.data?.find(order => order.orderID === removeID) : null;
    const [orderStatusCode, setOrderStatusCode] = useState(null);
    const handleSearch = () => {
        if (searchQuery.trim() === "") return;
        window.open(`/order/order-tracking?search=${encodeURIComponent(searchQuery)}`, '_blank');
    };
    const [showRemoveTrip, setShowRemoveTrip] = useState(false);

    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }

    useEffect(() => {
        getDriverList();
    }, []);

    useEffect(() => {
        if (ordersResult?.data) {
            setAssignedOrders(ordersResult?.data?.data)
        }
        if (ordersResult?.error) {
            setAssignedOrders([])
        }
    }, [ordersResult])

    useEffect(() => {
        divisionIdRef.current = divisionId;
    }, [divisionId]);
    useEffect(() => {
        const fetchData = async () => {
            if (divisionIdRef.current) {
                try {
                    await getAllOpenTripOrders(divisionIdRef.current);
                } catch (error) {
                    console.error(error);
                }
            } else {
                // setOrders([]);
            }

        };

        fetchData();
    }, [getAllOpenTripOrders, divisionId, singleOrderData]);

    useEffect(() => {
        const intervalId = setInterval(async () => {
            if (divisionId) {
                console.log('fetch orders')
            }
        }, 60000); // ping every 60 seconds
        return () => clearInterval(intervalId);
    }, []);

    const loadingHandler = () => {
        setisOpen(2)
    }
    const outboundHandler = () => {
        setisOpen(3)
    }
    const inboundHandler = () => {
        setisOpen(4)
    }
    const allHandler = () => {
        setisOpen(1)
    }

    const addOrderToTrip = async (orderNumber) => {
        if (!selectedTrip) {
            toast.error('Please select a trip', { position: 'top-center' });
        }
        const lineHauler = orderNumber ? ordersResult?.data?.data?.find(order => order.orderNumber === orderNumber)?.lineHauler : null;
        if (lineHauler && selectedTripDetails.data?.data?.lineHauler !== lineHauler) {
            toast.error('Line haulers do not match', { position: 'top-center' }); {
                return;
            }
        }
        const result = await assignTripToOrder({ divisionId: divisionId, orderNumber: orderNumber, tripId: selectedTrip.tripID, tripNo: selectedTrip.tripNo });
        if (result.data.statusCode === 200) {
            refetchTripOrders()
            getAllOpenTripOrders(divisionId)
            getTripOrdersClassification({ tripStatus: statusMap[selectedTrip?.tripStatusCode], tripId: selectedTrip.tripID, divisionId: divisionId })
            toast.success('Order added to trip successfully', { position: 'top-center' });
        }
    }

    return (
        <div>
            <Wrapper>
                <Container fluid>
                    <div className="longHaulTrip">
                        <h3>Trip Dispatch</h3>
                        <RemoveTrip
                            showRemoveTrip={showRemoveTrip}
                            setShowRemoveTrip={setShowRemoveTrip}
                            selectedTrip={selectedTrip}
                            divisionId={divisionId}
                            getAllOpenTripOrders={getAllOpenTripOrders}
                            getTripOrdersClassification={getTripOrdersClassification}
                            orderNumber={orderNumber}
                            orderID={orderID}
                        />
                        <PickupModal
                            showPickupModal={showPickupModal}
                            setShowPickupModal={setShowPickupModal}
                            orderNumber={orderNumber}
                            orderID={orderID}
                            divisionId={divisionId}
                            orderStatusCode={orderStatusCode}
                            getAllOpenTripOrders={getAllOpenTripOrders}
                            assignDriverCheckbox={assignDriverCheckbox}
                            selectedTrip={selectedTrip}
                            getTripOrdersClassification={getTripOrdersClassification}
                            refetchTripOrders={refetchTripOrders}
                        />
                        <RemoveDriverCheckbox
                            showRemoveDriverCheckbox={showRemoveDriverCheckbox}
                            setShowRemoveDriverCheckbox={setShowRemoveDriverCheckbox}
                            orderNumber={orderNumber}
                            orderID={orderID}
                            divisionId={divisionId}
                            orderStatusCode={orderStatusCode}
                            getAllOpenTripOrders={getAllOpenTripOrders}
                            selectedTrip={selectedTrip}
                            getTripOrdersClassification={getTripOrdersClassification}
                        />
                        <RemoveDriver
                            removeDriverPopup={removeDriverPopup}
                            setRemoveDriverPopup={setRemoveDriverPopup}
                            selectedOrder={selectedOrder}
                            divisionId={divisionId}
                            removeOrder={removeOrder}
                            removeOrderTrip={removeOrderTrip}
                            getAllOpenTripOrders={getAllOpenTripOrders}
                            getTripOrdersClassification={getTripOrdersClassification}
                            selectedTrip={selectedTrip}
                            refetchTripOrders={refetchTripOrders}
                        />
                        <TransferPickup
                            orderNumber={orderNumber}
                            orderID={orderID}
                            showPickupTransfer={showPickupTransfer}
                            setShowPickupTransfer={setShowPickupTransfer}
                            selectedDriverForTransfer={selectedDriverForTransfer}
                            selectedOrder={selectedOrder}
                            divisionId={divisionId}
                            getAllOpenTripOrders={getAllOpenTripOrders}
                            selectedTrip={selectedTrip}
                            getTripOrdersClassification={getTripOrdersClassification}
                            vehiclesByDivision={vehiclesByDivision}
                            servicesByDivision={servicesByDivision}
                        />
                        <TransferDelivery
                            orderNumber={orderNumber}
                            orderID={orderID}
                            showDeliveryTransfer={showDeliveryTransfer}
                            setShowDeliveryTransfer={setShowDeliveryTransfer}
                            selectedDriverForTransfer={selectedDriverForTransfer}
                            selectedOrder={selectedOrder}
                            divisionId={divisionId}
                            getAllOpenTripOrders={getAllOpenTripOrders}
                            selectedTrip={selectedTrip}
                            getTripOrdersClassification={getTripOrdersClassification}
                            vehiclesByDivision={vehiclesByDivision}
                            servicesByDivision={servicesByDivision}
                        />
                    </div>
                    <fieldset className="mt-3 shadow bg-body">
                        <Row className="d-flex justify-content-between">
                            <Col xs={12} xl={12} xxl={6} className="d-flex gap-2 flex-column flex-md-row h-100 mb-2 mb-xxl-0">
                                <div className="tripButtons" role="group" aria-label="Basic example">
                                    <button type="button" className={`btn active px-4  ${isOpen === 1 && "activenew"}`} onClick={() => allHandler()}>All</button>
                                    <button type="button" className={`btn active px-4  ${isOpen === 2 && "activenew"}`} onClick={() => loadingHandler()} >Loading</button>
                                    <button type="button" className={`btn active px-4  ${isOpen === 3 && "activenew"}`} onClick={() => outboundHandler()} >Outbound</button>
                                    <button type="button" className={`btn active px-4  ${isOpen === 4 && "activenew"}`} onClick={() => inboundHandler()} >Inbound</button>
                                </div>
                                <Col xs={12} md={4}>
                                    <Form.Group controlId="drivernumber" >
                                        <FloatingLabel controlId="floatingSelectGrid" label="Select division" >
                                            <Form.Select aria-label="Floating label select example" name="divisionId"
                                                onChange={(e) => {
                                                    setIsEditActiveTrip(false)
                                                    setSelectedTrip(null)
                                                    setShowNewTrip(false)
                                                    setSelectedDriver(null)
                                                    setAssignedOrders([])
                                                    setSelectedOrder(null)
                                                    if (e.target.value === '') {
                                                        setDivisionId(null);
                                                        divisionIdRef.current = null;
                                                    } else {
                                                        setDivisionId(e.target.value);
                                                        getDriverList(e.target.value)
                                                    }
                                                }
                                                }>
                                                <option value="">Select</option>
                                                {divisionList?.data?.map((data, index) => (
                                                    <option key={index} value={data?.divisionId} >{data?.divisionName}</option>
                                                ))}
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            </Col>
                            <Col xs={12} xl={12} xxl={6} className="d-flex flex-column flex-md-row h-100 justify-content-start justify-content-xl-end gap-2" style={{ minHeight: "48px" }}>
                                <Button style={{ height: "48px" }} className="btn btn-secondary" disabled={divisionId === null || isEditActiveTrip} onClick={() => {
                                    if (!isEditActiveTrip) {
                                        setShowNewTrip(true);
                                        setisOpen(2);
                                        setIsEditActiveTrip(false)
                                    }
                                }} >New Trip</Button>
                                <TextField value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" label="Search Order" />
                                <Button style={{ height: "48px", width: "100px" }} variant="outline-primary" onClick={handleSearch}> Search </Button>
                                <div >
                                    <NowLater nowLater={nowLater} setNowLater={setNowLater} />
                                </div>
                            </Col>
                        </Row>
                    </fieldset>
                    <Row className="mb-3">
                        <Col xs={12} md={8}>
                            {showNewTrip || isEditActiveTrip ?
                                <LoadingPage
                                    divisionId={divisionId}
                                    selectedDriver={selectedDriver}
                                    driverList={result}
                                    setShowNewTrip={setShowNewTrip}
                                    isEditActiveTrip={isEditActiveTrip}
                                    setIsEditActiveTrip={setIsEditActiveTrip}
                                    selectedTripDetails={selectedTripDetails}
                                    setSelectedTrip={setSelectedTrip}
                                    selectedTab={isOpen}
                                    classificationRadio={classificationRadio}
                                    setClassificationRadio={setClassificationRadio}
                                    getSelectedTripDetails={getSelectedTripDetails}
                                /> :
                                null}
                            <Draggable>
                                <Accordion defaultActiveKey="0" className="mt-2" >
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Button className="mb-0">
                                            Active Trip List
                                        </Accordion.Button>
                                        <Accordion.Body className="p-0">
                                            <div
                                                className="mb-3"
                                                style={{ height: isOpen === 2 || selectedOrder || selectedTrip ? "580px" : "100%" }}
                                            >
                                                <ActiveTripList
                                                    divisionId={divisionId}
                                                    selectedTrip={selectedTrip}
                                                    setSelectedTrip={setSelectedTrip}
                                                    isOpen={isOpen}
                                                    setIsEditActiveTrip={setIsEditActiveTrip}
                                                    getSelectedTripDetails={getSelectedTripDetails}
                                                    getTripOrdersClassification={getTripOrdersClassification}
                                                />
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Draggable>
                            {selectedOrder &&
                                <OrderDetailsMin
                                    setSelectedOrder={setSelectedOrder}
                                    selectedOrder={selectedOrder}
                                />
                            }
                        </Col>
                        <>
                            <Col xs={12} md={4}>
                                <Draggable>
                                    <div>
                                        <DriverDetails selectedDriver={selectedDriver} />
                                        <AddActiveDriver
                                            selectedDriver={selectedDriver}
                                            fetchDrivers={fetchDrivers}
                                            divisionId={divisionId}
                                            getDriverList={getDriverList}
                                            driverListResult={driverListResult}
                                            assignedOrders={assignedOrders}
                                        />
                                        <DriverList
                                            fetchDrivers={fetchDrivers}
                                            result={result}
                                            selectedDriver={selectedDriver}
                                            setSelectedDriver={setSelectedDriver}
                                            divisionId={divisionId}
                                            getAssignedOrdersToDriver={getAssignedOrdersToDriver}
                                            getDriverList={getDriverList}
                                            setAssignedOrders={setAssignedOrders}
                                        />
                                    </div>
                                </Draggable>
                            </Col>
                        </>
                    </Row>
                    {selectedTrip &&
                        <Draggable>
                            <div>
                                <DynamicOrdersTable
                                    boardType="TRIP_BOARD"
                                    selectedTrip={selectedTrip}
                                    setSelectedOrder={setSelectedOrder}
                                    getDetails={getDetails}
                                    divisionIdRef={divisionIdRef}
                                    classificationRadio={classificationRadio}
                                    tripOrdersClassification={tripOrdersClassification}
                                    getTripOrdersClassification={getTripOrdersClassification}
                                    ordersResult={ordersResult}
                                    nowLater={nowLater}
                                    addOrderToTrip={addOrderToTrip}
                                    setShowPickupTransfer={setShowPickupTransfer}
                                    setShowDeliveryTransfer={setShowDeliveryTransfer}
                                    selectedDriver={selectedDriver}
                                    setOrderNumber={setOrderNumber}
                                    setOrderID={setOrderID}
                                    selectedDriverForTransfer={selectedDriverForTransfer}
                                    driverType={driverType}
                                    getAllOpenTripOrders={getAllOpenTripOrders}
                                    setRemoveDriverPopup={setRemoveDriverPopup}
                                    setShowRemoveDriverCheckbox={setShowRemoveDriverCheckbox}
                                    setRemoveID={setRemoveID}
                                    setShowPickupModal={setShowPickupModal}
                                    setOrderStatusCode={setOrderStatusCode}
                                    setAssignDriverCheckbox={setAssignDriverCheckbox}
                                    setShowRemoveTrip={setShowRemoveTrip}
                                    refetchTripOrders={refetchTripOrders}
                                />
                            </div>
                        </Draggable>
                    }
                    <Draggable>
                        <div>
                            <DynamicOrdersTable
                                boardType="OPEN_BOARD"
                                divisionIdRef={divisionIdRef}
                                getDetails={getDetails}
                                ordersResult={ordersResult}
                                nowLater={nowLater}
                                addOrderToTrip={addOrderToTrip}
                                setShowPickupTransfer={setShowPickupTransfer}
                                setShowDeliveryTransfer={setShowDeliveryTransfer}
                                setSelectedOrder={setSelectedOrder}
                                selectedDriver={selectedDriver}
                                setOrderNumber={setOrderNumber}
                                setOrderID={setOrderID}
                                selectedDriverForTransfer={selectedDriverForTransfer}
                                driverType={driverType}
                                getAllOpenTripOrders={getAllOpenTripOrders}
                                setRemoveDriverPopup={setRemoveDriverPopup}
                                setShowRemoveDriverCheckbox={setShowRemoveDriverCheckbox}
                                setRemoveID={setRemoveID}
                                setShowPickupModal={setShowPickupModal}
                                setOrderStatusCode={setOrderStatusCode}
                                setAssignDriverCheckbox={setAssignDriverCheckbox}
                            />
                        </div>
                    </Draggable>
                </Container>
            </Wrapper>
        </div >
    )
}
export default TripDispatch;

